<template>
    <intelligence-shell
        :title="$t('pages.intelligence.supply_demand.title')"
        :subtitle="$t('pages.intelligence.supply_demand.subtitle')"
        @filters-change="onFiltersChange"
    >
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.supply_demand.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.supply_demand.error') }}
        </div>

        <template v-else-if="supplyDemand">
            <intelligence-supply-demand-kpi-cards :totals="supplyDemand.totals"></intelligence-supply-demand-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-supply-demand-chart :rows="supplyDemand.rows"></intelligence-supply-demand-chart>
                <intelligence-supply-demand-table :rows="supplyDemand.rows"></intelligence-supply-demand-table>
            </div>
        </template>
    </intelligence-shell>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceShell from 'components/page-elements/intelligence/IntelligenceShell'
    import IntelligenceSupplyDemandKpiCards from 'components/page-elements/intelligence/IntelligenceSupplyDemandKpiCards'
    import IntelligenceSupplyDemandChart from 'components/page-elements/intelligence/IntelligenceSupplyDemandChart'
    import IntelligenceSupplyDemandTable from 'components/page-elements/intelligence/IntelligenceSupplyDemandTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceShell,
            IntelligenceSupplyDemandKpiCards,
            IntelligenceSupplyDemandChart,
            IntelligenceSupplyDemandTable,
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                supplyDemand: null,
                filters: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.supply_demand.title')
            },
        },

        methods: {
            onFiltersChange(filters) {
                this.filters = filters
                this.loadSupplyDemand()
            },

            loadSupplyDemand() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getSupplyDemand(this.filters)
                    .then((response) => {
                        this.supplyDemand = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.supplyDemand = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
